/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import AccountPreferences from './main';

export const index = (context, next) => {
    context.primary = <AccountPreferences />;
    next();
};
